import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Button, Combobox } from '@salesforce/design-system-react';

import { SelectAgainComboboxGroup } from '../';

import './SelectAgainRow.scss';

class SelectAgainRow extends Component {
  renderDeleteButton() {
    if (this.props.assetType !== 'default') {
      return (
        <Button
          className="select-again-delete-rule-button"
          iconCategory="utility"
          iconName="delete"
          iconVariant="border-filled"
          variant="icon"
          onClick={this.props.onDeleteRule}
        />
      );
    }
    return null;
  }

  selectionFor(assetType) {
    return {
      id: assetType,
      label: assetType,
      value: assetType
    };
  }

  currentSelection() {
    const assetType = this.props.assetType;
    return assetType ? [this.selectionFor(assetType)] : [];
  }

  renderAssetTypeDropdown() {
    const { formatMessage } = this.props.intl;
    const options = this.props.availableAssetTypes.map(
      this.selectionFor.bind(this)
    );
    return (
      <Combobox
        labels={{
          label: formatMessage({
            id: 'components.ecs.rules.selection.assetClass'
          })
        }}
        options={options}
        selection={this.currentSelection()}
        events={{
          onSelect: (evt, data) => {
            if (data.selection.length > 0) {
              this.props.onRuleChange({ asset_type: data.selection[0].value });
            }
          }
        }}
        variant="readonly"
      />
    );
  }

  renderAssetTypeSelection() {
    if (this.props.assetType !== 'default') {
      return (
        <div className="select-again-combobox-group">
          <span>{this.renderAssetTypeDropdown()}</span>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="select-again-row-container">
        <div className="select-again-row">
          {this.renderAssetTypeSelection()}
          <SelectAgainComboboxGroup
            open={this.props.open}
            click={this.props.click}
            max_selection={this.props.max_selection}
            assetType={this.props.assetType}
            onChange={this.props.onRuleChange}
          />
          {this.renderDeleteButton()}
        </div>
      </div>
    );
  }
}

SelectAgainRow.propTypes = {
  assetType: PropTypes.string,
  selectable: PropTypes.bool,
  availableAssetTypes: PropTypes.array,
  onDeleteRule: PropTypes.func,
  onRuleChange: PropTypes.func.isRequired,
  open: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  click: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  max_selection: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  intl: intlShape.isRequired
};

export default injectIntl(SelectAgainRow);
